import Component from "./WellnessEnrollmentModal";

export default Component;
